import { render, staticRenderFns } from "./CreateIntermediarySupplierDialog.vue?vue&type=template&id=6896c220&scoped=true&"
import script from "./CreateIntermediarySupplierDialog.vue?vue&type=script&lang=js&"
export * from "./CreateIntermediarySupplierDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateIntermediarySupplierDialog.vue?vue&type=style&index=0&id=6896c220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896c220",
  null
  
)

/* custom blocks */
import block0 from "./CreateIntermediarySupplierDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports